export default __webpack_public_path__ + "static/media/Tesso.091cc49f.jpg";